import './CashinClosingModeExpandRow.less';
import clsx from 'clsx';
import React, { useEffect } from 'react';
import i18n from '../../../common/i18n';

import CheckButton from '../../forms/CheckButton';
import CashinClosingOdds from './CashinClosingOdds';
import { useCashinClosingPickRows } from './useCashinHooks';
import { PickState } from '../constants';
import ErrorActiveCheckBox from '../../../icons/ErrorActiveCheckbox';
import { dispatch, useReframe } from 'nike-re-framejs';
import {
    deleteFromChosenAndDisabledPicks,
    disableUnavailablePickIfChosen,
    enableRunningPickIfNotChosen
} from '../handlers';
import { isCashinClosingCheckboxChecked } from '../subs';
import { useDarkTheme } from '../../../common/theme';

const callCheckBoxChange = (active, pickState, cashinClosingTransactionActive, bet, ticketId) => {
    if (!active || cashinClosingTransactionActive) return;
    // ak je checkbox zaskrtnuty a zaroven neprebieha transakcia:

    if (pickState === PickState.UNAVAILABLE) {
        // ak je nedostupny a bol v chosen, tak ho dam do disabled - DONE
        dispatch(
            disableUnavailablePickIfChosen({ ticketId, betId: bet.get('betId'), selectionCode: bet.get('pickId') })
        );
        return;
    }

    if (pickState === PickState.RUNNING) {
        // ak je running a a je v disabled, dam ho do choosen
        dispatch(enableRunningPickIfNotChosen({ ticketId, betId: bet.get('betId'), selectionCode: bet.get('pickId') }));
        return;
    }

    if (pickState === PickState.FINISHED) {
        // ak je finished tak ho unchecknem a odstranim z oboch poli
        dispatch(deleteFromChosenAndDisabledPicks({ ticketId, betId: bet.get('betId') }));
        return;
    }
};

function CashinClosingModeExpandRow({
    bet,
    currentCashinOdds,
    onClick,
    onToggleDisabledPick,
    mobile,
    pickState,
    cashinClosingTransactionActive,
    ticketId
}) {
    const { subscribe } = useReframe();
    const isDarkTheme = useDarkTheme();
    const checked = subscribe(isCashinClosingCheckboxChecked(ticketId, bet.get('betId')));
    const { disabled, hidden } = useCashinClosingPickRows(pickState);
    const hideClosingOdds = disabled && !cashinClosingTransactionActive;
    const isClosingTransactionActiveAndNotChecked = !checked && cashinClosingTransactionActive;

    useEffect(() => {
        callCheckBoxChange(checked, pickState, cashinClosingTransactionActive, bet, ticketId);
    }, [pickState, checked, bet, cashinClosingTransactionActive, ticketId]);

    function handleClick() {
        onClick(bet);
    }

    function handleErrorClick() {
        onToggleDisabledPick(bet);
    }

    return hidden || isClosingTransactionActiveAndNotChecked ? null : mobile ? (
        <div className="flex cashin-closing-container mobile-top py-5">
            <div className="flex items-center flex-1 checkbox-mobile-padding">
                <CashinClosingCheckButton
                    disabled={disabled}
                    active={checked}
                    pickState={pickState}
                    handleClick={handleClick}
                    handleErrorClick={handleErrorClick}
                />
            </div>
            {hideClosingOdds ? null : <CashinClosingOdds odds={currentCashinOdds} mobile />}
        </div>
    ) : (
        <>
            <hr className="line-breaker" />
            <div
                className={clsx('flex cashin-closing-container py-2 pl-10', {
                    'cashin-closing-dark': isDarkTheme
                })}
            >
                <div className="cashin-closing-checkbox-container">
                    <CashinClosingCheckButton
                        disabled={disabled}
                        active={checked}
                        pickState={pickState}
                        handleClick={handleClick}
                        handleErrorClick={handleErrorClick}
                    />
                </div>
                <div className="closing-odds-padding">
                    {hideClosingOdds ? null : <CashinClosingOdds odds={currentCashinOdds} mobile={false} />}
                </div>
            </div>
        </>
    );
}

function CashinClosingCheckButton({ disabled, handleClick, active, pickState, handleErrorClick }) {
    return pickState === PickState.UNAVAILABLE && active ? (
        <ErrorActiveCheckBox onErrorCheckboxClick={handleErrorClick}>
            {i18n('nui.ticketus.cashin.closing.offer.checkbox.notAvailable')}
        </ErrorActiveCheckBox>
    ) : (
        <CheckButton
            className={clsx('cashin-closing-checkbox', { disabled: disabled })}
            active={active}
            disabled={disabled}
            onClick={handleClick}
            data-atid="cashin-closing-checkbox"
            data-testid="cashin-closing-checkbox"
        >
            {active
                ? i18n('nui.ticketus.cashin.closing.offer.checkbox.active')
                : i18n('nui.ticketus.cashin.closing.offer.checkbox')}
        </CheckButton>
    );
}

export default CashinClosingModeExpandRow;
